import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailService {

  private pathApi = this.config.setting['pathApi'] + "bps/auditTrail/";
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient, private config: AppConfig) {}

  getAll(obj: any) : Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj, {headers: this.headers, observe: 'response'});
  }

  getValueChanges(id: number, utilityId: number) : Observable<any> {
    return this.http.get(`${this.pathApi}getValueChanges/${id}?utilityId=${utilityId}`, {headers: this.headers, observe: 'response'});
  }

  download(obj: any) : Observable<any> {
    return this.http.post(`${this.pathApi}downloadFile`, obj, {headers: this.headers, observe: 'response'});
  }
}
